import { render, staticRenderFns } from "./appealReviewStatusModal.vue?vue&type=template&id=0386da63&scoped=true"
import script from "./appealReviewStatusModal.vue?vue&type=script&lang=js"
export * from "./appealReviewStatusModal.vue?vue&type=script&lang=js"
import style0 from "./appealReviewStatusModal.vue?vue&type=style&index=0&id=0386da63&prod&lang=scss&scoped=true"
import style1 from "./appealReviewStatusModal.vue?vue&type=style&index=1&id=0386da63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386da63",
  null
  
)

export default component.exports